// Client access to the curve's cumulative trading volume since launch.
//
// The api-server sums every Buy.usdsIn and Sell.usdsOut emitted by the curve
// (see routes/curve-volume.ts), so the total is the real USDS that has moved
// through the curve. Every figure is an on-chain reading; we just fetch and
// refresh the running total.
import { useQuery } from "@tanstack/react-query";
import { apiBase } from "@/lib/api-base";

export interface CurveVolumePayload {
  /** USDS in on buys + USDS out on sells, in wei (18 decimals), as a string. */
  totalVolumeUsds: string;
  buyVolumeUsds: string;
  sellVolumeUsds: string;
  fromBlock: number;
  toBlock: number;
  updatedAt: number;
}

async function fetchCurveVolume(): Promise<CurveVolumePayload> {
  const res = await fetch(`${apiBase()}/curve/volume`);
  if (!res.ok) throw new Error("could not load curve volume");
  return (await res.json()) as CurveVolumePayload;
}

export function useCurveVolume() {
  return useQuery({
    queryKey: ["curve-volume"],
    queryFn: fetchCurveVolume,
    refetchInterval: 5 * 60_000,
    staleTime: 5 * 60_000,
  });
}
